import React from "react";
import { Switch, FormControlLabel } from "@mui/material";
import { styled } from "@mui/system";
import "./fraudToggle.css";

const StyledSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    color: "#D0D5DD",
    "&.Mui-checked": {
      color: "#099250",
      "& + .MuiSwitch-track": {
        backgroundColor: "#D1FADF",
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-track": {
    backgroundColor: "#F2F4F7",
    opacity: 1,
  },
}));

const FraudToggle = ({
  checked = false,
  onChange,
  disabled = false,
  label = "Mark as Fraudulent",
  size = "medium",
}) => {
  return (
    <div className="fraud-toggle-container">
      <FormControlLabel
        control={
          <StyledSwitch
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            size={size}
          />
        }
        label={label}
        className="fraud-toggle-label"
      />
    </div>
  );
};

export default FraudToggle;

